import { Icon, View } from "@aws-amplify/ui-react";

export default function InsuranceSectionIcon() {
  return (
    <View
      width="78px"
      height="78px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      shrink="0"
      position="relative"
      padding="0px 0px 0px 0px"
    >
      <Icon
        width="78px"
        height="78px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 78.00016784667969,
          height: 78.00016784667969,
        }}
        paths={[
          {
            d: "M39.0001 78.0002C60.5392 78.0002 78.0002 60.5392 78.0002 39.0001C78.0002 17.4609 60.5392 0 39.0001 0C17.4609 0 0 17.4609 0 39.0001C0 60.5392 17.4609 78.0002 39.0001 78.0002Z",
            fill: "rgba(73,160,174,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="0%"
        bottom="0%"
        left="0%"
        right="0%"
      ></Icon>
      <Icon
        width="36.77px"
        height="50.82px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 44.3229598076457,
          height: 55.98733540789635,
        }}
        paths={[
          {
            d: "M36.7675 0L0 0L0 50.8244L36.7675 50.8244L36.7675 0Z",
            fill: "rgba(255,255,255,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="80.06%"
        bottom="-45.22%"
        left="79.94%"
        right="-27.07%"
        transformOrigin="top left"
        transform="rotate(170.93deg)"
      ></Icon>
      <View
        padding="0px 0px 0px 0px"
        width="16.42px"
        height="16.42px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="22.43%"
        bottom="56.51%"
        left="38.1%"
        right="40.85%"
      >
        <Icon
          width="16.42px"
          height="16.42px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 16.422870635986328,
            height: 16.42287254333496,
          }}
          paths={[
            {
              d: "M8.21144 16.4229C12.7465 16.4229 16.4229 12.7465 16.4229 8.21144C16.4229 3.67638 12.7465 0 8.21144 0C3.67639 0 0 3.67638 0 8.21144C0 12.7465 3.67639 16.4229 8.21144 16.4229Z",
              fill: "rgba(241,237,205,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0%"
          bottom="0%"
          left="0%"
          right="0%"
        ></Icon>
        <View
          padding="0px 0px 0px 0px"
          width="12.01px"
          height="12.01px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="13.45%"
          bottom="13.44%"
          left="13.46%"
          right="13.43%"
        >
          <Icon
            width="4.99px"
            height="12.01px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 4.991043567657471,
              height: 12.007416725158691,
            }}
            paths={[
              {
                d: "M4.9769 10.6418C5.06742 11.1682 4.7139 11.6684 4.18872 11.7583L2.81365 11.9935C2.28831 12.0833 1.78765 11.73 1.69779 11.2046L0.014127 1.36564C-0.0763925 0.839149 0.277621 0.339646 0.802963 0.250443L2.1787 0.0139409C2.70404 -0.0759203 3.20288 0.278093 3.2934 0.803435L4.9769 10.6418Z",
                fill: "rgba(214,33,39,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="0%"
            bottom="0%"
            left="29.22%"
            right="29.22%"
          ></Icon>
          <Icon
            width="12.01px"
            height="4.99px"
            viewBox={{
              minX: 0,
              minY: 0,
              width: 12.007787704467773,
              height: 4.991986274719238,
            }}
            paths={[
              {
                d: "M1.36552 4.97801C0.839684 5.06787 0.339522 4.71501 0.249661 4.18851L0.0138168 2.81344C-0.0755506 2.2881 0.277969 1.78876 0.803311 1.69758L10.6423 0.0139215C11.1681 -0.0759396 11.6683 0.278732 11.7581 0.803416L11.994 2.17734C12.0834 2.70383 11.7292 3.20399 11.2045 3.29385L1.36552 4.97801Z",
                fill: "rgba(214,33,39,1)",
                fillRule: "nonzero",
              },
            ]}
            display="block"
            gap="unset"
            alignItems="unset"
            justifyContent="unset"
            position="absolute"
            top="29.21%"
            bottom="29.21%"
            left="0%"
            right="0%"
          ></Icon>
        </View>
      </View>
      <View
        padding="0px 0px 0px 0px"
        width="31.55px"
        height="16.26px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="48.63%"
        bottom="30.53%"
        left="32.83%"
        right="26.72%"
      >
        <Icon
          width="29.99px"
          height="1.9px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 29.909744278170137,
            height: 6.602420567962781,
          }}
          paths={[
            {
              d: "M29.9853 0L0 0L0 1.89745L29.9853 1.89745L29.9853 0Z",
              fill: "rgba(232,72,73,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="11.53%"
          bottom="76.8%"
          left="94.8%"
          right="-89.83%"
          transformOrigin="top left"
          transform="rotate(170.93deg)"
        ></Icon>
        <Icon
          width="29.98px"
          height="1.9px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 29.90925268286628,
            height: 6.602342062064054,
          }}
          paths={[
            {
              d: "M29.9848 0L0 0L0 1.89745L29.9848 1.89745L29.9848 0Z",
              fill: "rgba(232,72,73,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="40.3%"
          bottom="48.02%"
          left="97.5%"
          right="-92.54%"
          transformOrigin="top left"
          transform="rotate(170.93deg)"
        ></Icon>
        <Icon
          width="29.99px"
          height="1.9px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 29.909742394663226,
            height: 6.602420267173784,
          }}
          paths={[
            {
              d: "M29.9853 0L0 0L0 1.89745L29.9853 1.89745L29.9853 0Z",
              fill: "rgba(232,72,73,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="70.91%"
          bottom="17.42%"
          left="100%"
          right="-95.04%"
          transformOrigin="top left"
          transform="rotate(170.93deg)"
        ></Icon>
      </View>
      <Icon
        width="18.75px"
        height="5.05px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 18.750045776367188,
          height: 5.050331115722656,
        }}
        paths={[
          {
            d: "M18.75 2.11092L18.8289 2.60466L19.3226 2.52579L19.2438 2.03212L18.75 2.11092ZM0.35105 5.05033L-0.142695 5.12917L-0.0638476 5.62296L0.42993 5.54407L0.35105 5.05033ZM0 2.85186L-0.0765284 2.35775L-0.572956 2.43464L-0.493745 2.9307L0 2.85186ZM18.4131 0L18.9069 -0.0788013L18.8285 -0.570286L18.3366 -0.494109L18.4131 0ZM18.6712 1.61718L0.272171 4.55659L0.42993 5.54407L18.8289 2.60466L18.6712 1.61718ZM0.844795 4.97149L0.493745 2.77302L-0.493745 2.9307L-0.142695 5.12917L0.844795 4.97149ZM0.0765284 3.34597L18.4897 0.494109L18.3366 -0.494109L-0.0765284 2.35775L0.0765284 3.34597ZM17.9194 0.0788013L18.2563 2.18972L19.2438 2.03212L18.9069 -0.0788013L17.9194 0.0788013Z",
            stroke: "rgba(232,72,73,1)",
            fillRule: "nonzero",
            strokeWidth: 1,
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="69.59%"
        bottom="23.94%"
        left="35.93%"
        right="40.03%"
      ></Icon>
      <Icon
        width="0.62px"
        height="36.77px"
        viewBox={{
          minX: 0,
          minY: 0,
          width: 36.40034093687473,
          height: 6.42084300311808,
        }}
        paths={[
          {
            d: "M0.615862 0L0 0L0 36.7662L0.615862 36.7662L0.615862 0Z",
            fill: "rgba(231,71,74,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="51.43%"
        bottom="1.44%"
        left="27.66%"
        right="71.55%"
        transformOrigin="top left"
        transform="rotate(-99.1deg)"
      ></Icon>
    </View>
  );
}
